import type React from 'react';
import { useIntl } from 'react-intl';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/components/ui/input-otp';

const LENGTH = 5;

type Props = {
  value: string;
  onChange: (value: string) => void;
  onComplete: (value: string) => void;
  hasError?: boolean;
  disabled?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
};

const CodeInput = ({
  value,
  onChange,
  onComplete,
  hasError,
  disabled,
  inputRef,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <InputOTP
      ref={inputRef}
      maxLength={LENGTH}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      pattern={REGEXP_ONLY_DIGITS}
      inputMode="numeric"
      disabled={disabled}
      autoFocus
      aria-label={formatMessage({
        id: 'sign-in-code-input-aria-label',
        defaultMessage: 'Verification code',
      })}
      aria-invalid={hasError || undefined}
      containerClassName="tw tw:justify-center"
    >
      <InputOTPGroup>
        {Array.from({ length: LENGTH }, (_, i) => (
          <InputOTPSlot
            key={i}
            index={i}
            aria-invalid={hasError || undefined}
          />
        ))}
      </InputOTPGroup>
    </InputOTP>
  );
};

export default CodeInput;
